import {
  LayoutDashboard,
  Receipt,
  UtensilsCrossed,
  CircleHelp,
  Settings,
  FileText,
  FileSpreadsheet,
  Package,
  ShoppingBag,
  ShieldCheck,
  CreditCard,
  Wallet,
  Warehouse,
  BarChart3,
  TrendingUp,
  Database,
  Tags,
  Store,
  Users,
  UserCog,
  Clock,
  Timer,
  Upload,
  Wine,
  Undo2,
  Beer,
  RotateCcw,
  Boxes,
  ArrowLeftRight,
  ArrowRightLeft,
  BookOpen,
  Newspaper,
  ClipboardList,
  IndianRupee,
  Coins,
  Code,
  Wrench,
  Landmark,
  Building2,
  ArrowDownUp,
  PiggyBank,
  ScrollText,
  SlidersHorizontal,
  type LucideIcon,
} from "lucide-react";

/** Map module identifiers to Lucide icons — each module gets a unique icon */
export const MODULE_ICON_MAP: Record<string, LucideIcon> = {
  // Sales
  uidashboard: LayoutDashboard,
  uibilling: Receipt,
  uitableorder: UtensilsCrossed,
  uimassinvoice: FileText,
  uimassinvoicesales: FileSpreadsheet,
  uimassstocktransfer: ArrowRightLeft,
  uicashentry: Coins,

  // Inventory
  uigrn: Upload,
  uigrnalcohol: Wine,
  "uigrn-nonalcohol": Beer,
  uigrnreturn: Undo2,
  "uigrn-nonalcoholreturn": RotateCcw,
  uiinventory: Boxes,
  uistocktransfer: ArrowLeftRight,
  uigodownstock: Warehouse,

  // Masters
  uimasters: Database,
  uimasspriceupdate: Tags,
  uisellingpricemaster: IndianRupee,
  uisupplier: UserCog,
  uidistmaster: Package,
  uischememaster: BookOpen,
  uiwobmaster: SlidersHorizontal,
  uitableorderconfig: Settings,

  // Reports
  uireportsv2: Newspaper,
  uicustomreports: ClipboardList,
  uitracker: Timer,
  uitransactions: ArrowDownUp,
  uitotalsalesacrossstores: TrendingUp,
  uigroupdashboard: BarChart3,

  // Finance
  uisupplierbillpayreq: CreditCard,
  uisupplierbillpay: Wallet,
  uipurchaseplanning: ShoppingBag,
  uistoreexpensesv3: PiggyBank,
  uistoreexpensescorrection: ScrollText,
  uiksbclledger: Landmark,
  uibankledger: Building2,

  // Admin
  uiadministration: ShieldCheck,
  uicontrolmanagement: SlidersHorizontal,
  uionboarding: Store,
  uiuser: Users,
  uishops: Store,
  uicronjobs: Clock,
  uiscript: Code,
  uiutilities: Wrench,

  // Other
  uihelp: CircleHelp,
};

export const DEFAULT_ICON: LucideIcon = LayoutDashboard;
